module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_3016.2c70979f.png";